<div class="wrapper-page wrapper-my-list">
  <tl-header></tl-header>
  <div class="wrapper-header-my-lists">
    <div class="header-my-lists">
      <span>
        {{'LISTS.favorite_lists' | translate}}
      </span>
    </div>
  </div>
  <div class="wrapper-content-my-lists favorite-lists">
    <div class="content-my-lists">
      <div class="filter-my-lists">
        <div class="wrapper-custom-search">
          <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
          <input type="text" placeholder="{{'NEW_TEXT.search' | translate}}" [(ngModel)]="searchTerm" (input)="onSearchChange($event)">
          <div (click)="resetSearch()" class="wrapper-delete-search">
            <img src="../../../assets/icons/outline/icon-close.svg" alt="">
          </div>
        </div>
      </div>
      <div class="wrapper-cards-list scroll-pagination" #favoriteListsContainter (scroll)="onScroll()"
        style="overflow-y: auto; height: 100%;">
        <div *ngFor="let list of favoriteLists" [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, list.id, 'cards']" class="wrapper-card-list">
          <img class="image-list" [src]="list.lyst_image_url ? list.lyst_image_url : 'assets/images/no-image.png'"
            alt="">
          <div class="wrapper-card-list-info" [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, list.id, 'cards']">
            <div class="wrapper-badges">
              <div class="badge gray">
                <span>{{list.lyst_items_count}} {{list.lyst_items_count === 1 ? ('LISTS.items' | translate) :
                  ('LISTS.items' | translate) }}</span>
              </div>
            </div>
            <span class="name-list">{{list | matchLocale}}</span>
            <span class="time-list">{{list.updated_at | timeAgo}}</span>
          </div>
          <div class="wrapper-right-element">
            <div class="wrapper-send-btn">
              <button (click)="addListerToFavorites(list); $event.stopPropagation()" class="custom-btn"
                [ngClass]="list.am_i_favorite_this_lyst ? 'custom-btn--circle-primary' : 'custom-btn--circle-outline'">
                <img src="../../../../assets/icons/fill/icon-heart.svg" alt="">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
